import type { TOC } from '@ember/component/template-only'
import { UiButtonLink } from 'teacher-ui-client/components/ui-button/link'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import endsWith from 'teacher-ui-client/helpers/ends-with'
import { t } from 'ember-intl'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'

interface Args {
  href?: string
}

export const EntriesButtonDownload: TOC<Args> = <template>
  {{#if @href}}
    <UiButtonLink href={{@href}} target="_blank" rel="noopener noreferrer" @appearance={{ButtonAppearance.regular}}>
      <PhosphorIcon @icon="phosphor-download-fill" />
      {{#if (endsWith @href ".pdf")}}
        {{t "components.tiles.entries.buttonPdf"}}
      {{else}}
        {{t "components.tiles.entries.buttonDownload"}}
      {{/if}}
    </UiButtonLink>
  {{/if}}
</template>

export default EntriesButtonDownload
